var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_160_6627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.35886 14.5148C9.59804 13.4448 13.2883 9.98048 13.2883 6.65402C13.2883 5.24047 12.7267 3.88481 11.7272 2.88528C10.7277 1.88575 9.37201 1.32422 7.95846 1.32422C6.54491 1.32422 5.18926 1.88575 4.18972 2.88528C3.19019 3.88481 2.62866 5.24047 2.62866 6.65402C2.62866 9.98048 6.31888 13.4448 7.55806 14.5148C7.6735 14.6016 7.81403 14.6486 7.95846 14.6486C8.1029 14.6486 8.24342 14.6016 8.35886 14.5148Z",
    stroke: "#99A1AF",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.95864 8.6536C9.06247 8.6536 9.95731 7.75876 9.95731 6.65493C9.95731 5.55109 9.06247 4.65625 7.95864 4.65625C6.8548 4.65625 5.95996 5.55109 5.95996 6.65493C5.95996 7.75876 6.8548 8.6536 7.95864 8.6536Z",
    stroke: "#99A1AF",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_160_6627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9894,
    height: 15.9894,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationDark);
export default __webpack_public_path__ + "static/media/locationDark.cea7f0938ef79bd2ff88055b983364fb.svg";
export { ForwardRef as ReactComponent };